import JsonSchema$anchorError from "./JsonSchema$anchorError.mjs";
/**
 * @public
 */
class EvaluationJsonSchema$anchorError extends JsonSchema$anchorError {}
export default EvaluationJsonSchema$anchorError;